import {
  type InfiniteData as InfiniteDataReact,
  type QueryKey,
  type UseInfiniteQueryOptions as UseInfiniteQueryOptionsReact,
  useInfiniteQuery as useInfiniteQueryReact,
} from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { defaultQueryOptions } from '../default-query-options';

export type InfiniteData<TData, TPageParameter = unknown> = InfiniteDataReact<TData, TPageParameter>;

export type UseInfiniteQueryOptions<
  TQueryFunctionData,
  TError,
  TData,
  TQueryKey extends QueryKey = QueryKey,
  TPageParameter = unknown,
> = UseInfiniteQueryOptionsReact<TQueryFunctionData, TError, TData, TQueryKey, TPageParameter>;

export const useInfiniteQuery = <
  TQueryFunctionData,
  TPageParameter = unknown,
  TError extends AxiosError = AxiosError,
  TData = InfiniteData<TQueryFunctionData>,
  TQueryKey extends QueryKey = QueryKey,
>(
  options: UseInfiniteQueryOptions<TQueryFunctionData, TError, TData, TQueryKey, TPageParameter>,
) =>
  useInfiniteQueryReact<TQueryFunctionData, TError, TData, TQueryKey, TPageParameter>({
    ...defaultQueryOptions,
    ...options,
  });
